import { Button, IconButton, styled } from '@mui/material';

export const RootStyled = styled('div')(({ theme }) => ({
  padding: theme.spacing(10),
  paddingTop: theme.spacing(2),
}));

export const HeaderContainerStyled = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginBottom: 20,
});

export const ArrowBackStyled = styled(IconButton)({
  marginLeft: -18,
});

export const TitlesStyled = styled('div')({
  margin: '20px 0',
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
});

export const MiddleOfThePageStyled = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: 20,
  '& input': {
    width: 55,
  },
  '& div': {
    display: 'flex',
    gap: 16,
  },
});

export const DefaultButtonOutlinedStyled = styled(Button)(({ theme }) => ({
  width: 250,
  height: 51,
  fontWeight: 'bold',
  color: theme.palette.primary.main,
}));

export const DefaultButtonContainedStyled = styled(Button)(({ theme }) => ({
  width: 250,
  height: 51,
  fontWeight: 'bold',
  color: theme.palette.global.white,
  backgroundColor: theme.palette.secondary.main,
  border: 'none',
}));
